import { clsx } from 'clsx'

import { Text } from '@buffer-mono/popcorn'

import { LinkifiedText } from '~publish/legacy/shared-components/LinkifiedText'
import { parseThreadsLinks } from '~publish/legacy/utils/channels/threads/helpers'

import { useCommentData } from '../../context/CommentContext'

import styles from './CommentText.module.css'

export const CommentText = (): JSX.Element | null => {
  const comment = useCommentData()

  if (!comment.text) {
    return null
  }

  if (comment.serviceType === 'threads') {
    return (
      <LinkifiedText
        links={parseThreadsLinks(comment.text)}
        whitespace="pre-wrap"
        newTab
        className={clsx(
          styles.commentText,
          comment.isDeleted && styles.deleted,
        )}
      >
        {comment.text}
      </LinkifiedText>
    )
  }

  return <Text>{comment.text}</Text>
}
